var _path, _path2, _path3, _path4, _path5, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 28,
    viewBox: "0 0 48 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6108 16.065L23.5615 18.2552L19.492 22.8661L8.03125 14.3543L22.8735 9.32414C23.0845 9.24849 23.2965 9.13821 23.5047 8.99147C23.7147 8.84291 23.9027 8.67611 24.0665 8.49383C24.4481 8.05817 24.6071 7.62889 24.5425 7.20599C24.4809 6.77853 24.1927 6.37932 23.6916 6.00473C23.232 5.66385 22.7434 5.51985 22.2211 5.56998C21.6978 5.62102 21.2555 5.84796 20.9009 6.2499C20.6937 6.48778 20.5674 6.72384 20.5135 6.9599C20.4682 7.19778 20.4894 7.46301 20.5906 7.7574L15.2905 9.60668C14.6949 8.3717 14.4762 7.18411 14.6361 6.04301C14.8029 4.90555 15.3415 3.81275 16.2667 2.76734C17.7083 1.13498 19.5219 0.225378 21.7103 0.0348905C23.9007 -0.156509 25.9244 0.439563 27.7852 1.82311C29.5603 3.14012 30.5769 4.76974 30.84 6.7047C31.1041 8.64421 30.5673 10.3695 29.2278 11.8862C28.7662 12.4066 28.2198 12.8614 27.5848 13.2506C26.9488 13.6352 25.9822 14.0699 24.6774 14.5539L20.6108 16.065Z",
    fill: "#373535"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.1358 27.7116H16.8281L24.6125 18.7395L32.1358 27.7116Z",
    fill: "#9E3437"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.0459 19.0497L15.6381 27.9991L18.8801 24.1579L7.28785 15.2065L4.0459 19.0497Z",
    fill: "#F8A334"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.00571 16.9986C0.425585 16.5684 0.0950509 16.0188 0.0179584 15.3489C-0.062025 14.6799 0.124924 14.0884 0.583624 13.5698C1.04907 13.0375 1.65328 12.7377 2.38566 12.6684C3.119 12.5982 3.77043 12.7769 4.35441 13.208C4.91718 13.6272 5.24097 14.1713 5.31132 14.8394C5.38648 15.5084 5.18604 16.1063 4.71771 16.6395C4.2619 17.1553 3.67214 17.4534 2.94362 17.5199C2.21798 17.5883 1.57137 17.4169 1.00571 16.9986Z",
    fill: "#F8A334"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1105_63967",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 27,
    y: 9,
    width: 21,
    height: 19
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.9619 9.33936H47.6197V27.4548H27.9619V9.33936Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1105_63967)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.0748 19.5523L46.3338 22.7524L46.2981 22.8116C44.9557 25.0437 43.0082 26.4774 40.442 27.1226C37.8864 27.7661 35.402 27.4745 33.0035 26.2504C32.1497 25.8138 31.3942 25.2788 30.7331 24.6481C30.075 24.0174 29.5199 23.3056 29.0737 22.5154C28.3144 21.1382 27.9434 19.7 27.9626 18.208C27.9829 16.7178 28.3934 15.3115 29.1865 13.989C29.8148 12.9454 30.6387 12.0522 31.6534 11.3131C32.6672 10.573 33.8014 10.0416 35.0561 9.71898C36.3378 9.37082 37.6194 9.26236 38.9001 9.39269C40.1827 9.51938 41.3854 9.87119 42.5071 10.4454C44.6185 11.5227 46.0977 13.0612 46.9544 15.0636C47.8062 17.0669 47.8419 19.1094 47.0507 21.182L40.8101 17.9947C40.6829 17.5281 40.4969 17.1398 40.2589 16.8199C40.0218 16.5055 39.7077 16.2484 39.3106 16.0452C38.612 15.6888 37.9076 15.5958 37.1858 15.7654C36.4621 15.9376 35.9215 16.3223 35.5591 16.9256C35.2064 17.5117 35.1351 18.1342 35.3404 18.7986C35.5456 19.4612 35.9687 19.9552 36.6008 20.2788C37.2272 20.595 37.8256 20.6944 38.3981 20.5768C38.9724 20.4556 39.5332 20.1138 40.0748 19.5523Z",
    fill: "#39B7E9"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.4696f0e753b7a26300848ecfc6779592.svg";
export { ForwardRef as ReactComponent };